// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VendorStats {
  flex: 1 1;
  min-height: 25rem;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  position: relative;
}
.VendorStats h1 {
  position: sticky;
  top: 0;
  width: 100%;
  font-size: 1.125rem;
  font-weight: 700;
  white-space: nowrap;
  color: var(--TextColor);
  height: 1.5rem;
  background: var(--Background);
}
.VendorStats .TableHeader {
  position: sticky;
  top: 1.5rem;
  width: 100%;
  padding: 0 0.5rem 0 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  min-height: 2.5rem;
  background: var(--Background);
}
.VendorStats .TableHeader .SearchContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1 1;
  height: 1.75rem;
}
.VendorStats .TableHeader .SearchContainer .Input {
  max-width: 15rem;
  height: 100%;
  position: relative;
}
.VendorStats .TableHeader .SearchContainer .Input input {
  padding: 0 2.25rem 0 0.5rem;
  width: 100%;
  height: 100%;
  background: var(--Foreground);
  color: var(--TextColor);
  border-radius: 0.25rem;
  font-size: 0.75rem;
  border: 0.0625rem solid var(--Stroke);
}
.VendorStats .TableHeader .SearchContainer .Input input::placeholder {
  font-size: 0.75rem;
}
.VendorStats .TableHeader .SearchContainer .Input svg {
  position: absolute;
  top: 50%;
  right: 0.5rem;
  transform: translateY(-50%);
}
.VendorStats .TableHeader span {
  font-size: 0.75rem;
  min-width: 6.25rem;
  text-align: center;
  color: var(--TextColor);
}
.VendorStats .TableRow {
  width: 100%;
  padding: 0.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  background: var(--Foreground);
  border-radius: 0.5rem;
  margin-top: 0.25rem;
}
.VendorStats .TableRow span {
  font-size: 0.75rem;
  min-width: 6.25rem;
  text-align: center;
  color: var(--TextColor);
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
}
.VendorStats .TableRow span:hover {
  color: var(--AccentColor);
  font-weight: 700;
}
.VendorStats .TableRow .Name {
  flex: 1 1;
  text-align: left;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.VendorStats .LoaderContainer {
  position: absolute;
  width: 100%;
  height: 100%;
  min-height: 60px;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(44, 44, 44, 0.3137254902);
  z-index: 1;
}

@media (max-width: 1200px) {
  .VendorStats .TableHeader span {
    font-size: 10px;
    min-width: 80px;
  }
  .VendorStats .TableRow span {
    font-size: 10px;
    min-width: 80px;
  }
}`, "",{"version":3,"sources":["webpack://./src/ClientComponents/VendorStats.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AACF;AAAE;EACE,gBAAA;EACA,MAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,6BAAA;AAEJ;AAAE;EACE,gBAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,6BAAA;AAEJ;AADI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAGN;AAFM;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;AAIR;AAHQ;EACE,2BAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;AAKV;AAHQ;EACE,kBAAA;AAKV;AAHQ;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,2BAAA;AAKV;AADI;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;AAGN;AAAE;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;EACA,qBAAA;EACA,mBAAA;AAEJ;AADI;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAGN;AADI;EACE,yBAAA;EACA,gBAAA;AAGN;AADI;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAGN;AAAE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,UAAA;AAEJ;;AAGA;EAGM;IACE,eAAA;IACA,eAAA;EAFN;EAMI;IACE,eAAA;IACA,eAAA;EAJN;AACF","sourcesContent":[".VendorStats{\n  flex: 1;\n  min-height: 25rem;\n  width: 100%;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n  position: relative;\n  h1{\n    position: sticky;\n    top: 0;\n    width: 100%;\n    font-size: 1.125rem;\n    font-weight: 700;\n    white-space: nowrap;\n    color: var(--TextColor);\n    height: 1.5rem;\n    background: var(--Background);\n  }\n  .TableHeader{\n    position: sticky;\n    top: 1.5rem;\n    width: 100%;\n    padding: 0 0.5rem 0 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-end;\n    min-height: 2.5rem;\n    background: var(--Background);\n    .SearchContainer{\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      flex: 1;\n      height: 1.75rem;\n      .Input{\n        max-width: 15rem;\n        height: 100%;\n        position: relative;\n        input{\n          padding: 0 2.25rem 0 0.5rem;\n          width: 100%;\n          height: 100%;\n          background: var(--Foreground);\n          color: var(--TextColor);\n          border-radius: 0.25rem;\n          font-size: 0.75rem;\n          border: 0.0625rem solid var(--Stroke);\n        }\n        input::placeholder{\n          font-size: 0.75rem;\n        }\n        svg{\n          position: absolute;\n          top: 50%;\n          right: 0.5rem;\n          transform: translateY(-50%);\n        }\n      }\n    }\n    span{\n      font-size: 0.75rem;\n      min-width: 6.25rem;\n      text-align: center;\n      color: var(--TextColor);\n    }\n  }\n  .TableRow{\n    width: 100%;\n    padding: 0.5rem;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-end;\n    background: var(--Foreground);\n    border-radius: 0.5rem;\n    margin-top: 0.25rem;\n    span{\n      font-size: 0.75rem;\n      min-width: 6.25rem;\n      text-align: center;\n      color: var(--TextColor);\n      font-weight: 600;\n      white-space: nowrap;\n      cursor: pointer;\n    }\n    span:hover{\n      color: var(--AccentColor);\n      font-weight: 700;\n    }\n    .Name{\n      flex: 1;\n      text-align: left;\n      cursor: pointer;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n  .LoaderContainer{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    min-height: 60px;\n    top: 0;\n    left: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #2C2C2C50;\n    z-index: 1;\n  }\n}\n\n\n@media (max-width: 1200px) {\n  .VendorStats{\n    .TableHeader{\n      span{\n        font-size: 10px;\n        min-width: 80px;\n      }\n    }\n    .TableRow{\n      span{\n        font-size: 10px;\n        min-width: 80px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
